/**
 * Featured Locations Slider Web Component
 * Uses Swiper.js for carousel functionality
 */

if (!customElements.get('featured-locations-slider')) {
  class FeaturedLocationsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      this.destroySwiper();
    }

    get sectionId() {
      return this.dataset.sectionId;
    }

    get autoplay() {
      return this.dataset.autoplay === 'true';
    }

    get autoplaySpeed() {
      return parseInt(this.dataset.autoplaySpeed, 10) || 5;
    }

    get showArrows() {
      return this.dataset.showArrows === 'true';
    }

    get showDots() {
      return this.dataset.showDots === 'true';
    }

    get slidesPerView() {
      return parseInt(this.dataset.slidesPerView, 10) || 4;
    }

    initSwiper() {
      const swiperEl = this.querySelector('.featured-locations__swiper');
      
      if (!swiperEl || typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiper(), 100);
        return;
      }

      const slidesCount = this.querySelectorAll('.swiper-slide').length;

      const swiperConfig = {
        slidesPerView: 1.2,
        spaceBetween: 15,
        grabCursor: true,
        watchOverflow: true,
        loop: slidesCount > this.slidesPerView,
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 15
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 25
          },
          1200: {
            slidesPerView: this.slidesPerView,
            spaceBetween: 30
          }
        }
      };

      if (this.autoplay) {
        swiperConfig.autoplay = {
          delay: this.autoplaySpeed * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      if (this.showArrows) {
        swiperConfig.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev')
        };
      }

      if (this.showDots) {
        swiperConfig.pagination = {
          el: this.querySelector('.swiper-pagination'),
          clickable: true
        };
      }

      this.swiper = new Swiper(swiperEl, swiperConfig);
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('featured-locations-slider', FeaturedLocationsSlider);
}

document.addEventListener('shopify:section:load', function(event) {
  const section = event.target;
  const slider = section.querySelector('featured-locations-slider');
  
  if (slider && slider.swiper) {
    slider.destroySwiper();
    slider.initSwiper();
  }
});

document.addEventListener('shopify:section:unload', function(event) {
  const section = event.target;
  const slider = section.querySelector('featured-locations-slider');
  
  if (slider) {
    slider.destroySwiper();
  }
});
